import script from "./DataSetting.vue?vue&type=script&setup=true&lang=ts"
export * from "./DataSetting.vue?vue&type=script&setup=true&lang=ts"

import "./DataSetting.vue?vue&type=style&index=0&id=30262488&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30262488"]])

export default __exports__